/**
 * CWR 2.4 — location + cancellation info row (mockup .sd-info).
 */
import type { HubServiceDetailDto, CancellationInfo } from '@/api/types';
import { formatLocation } from '../detailFormat';
import { LocationIcon, CancellationIcon } from '../detailIcons';
import { PhoneIcon } from '@/pages/BookSessionPage/catalogIcons';
import styles from '../SessionDetailPage.module.css';

export interface DetailInfoRowProps {
  location: HubServiceDetailDto['location'];
  cancellation: CancellationInfo;
}

export function DetailInfoRow({ location, cancellation }: DetailInfoRowProps) {
  const loc = formatLocation(location);
  return (
    <div className={styles.info} data-testid="detail-info">
      <div className={styles.infoCell}>
        {location.isByPhone ? PhoneIcon : LocationIcon}
        <div>
          <div className={styles.infoT1}>{loc.t1}</div>
          {loc.t2 && <div className={styles.infoT2}>{loc.t2}</div>}
        </div>
      </div>
      <div className={styles.infoCell}>
        {CancellationIcon}
        <div>
          <div className={styles.infoT1}>Cancellation</div>
          <div className={styles.infoT2}>{cancellation.displayText}</div>
        </div>
      </div>
    </div>
  );
}
